import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'gig-positive-negative-chart',
  standalone: true,
  imports: [CommonModule, ChartModule, CardModule],
  templateUrl: './positive-negative-chart.component.html',
  styleUrl: './positive-negative-chart.component.scss'
})
export class PositiveNegativeChartComponent implements OnInit{
    @Input() data: any;
  @Input() options: any;

  constructor() { }

  ngOnInit(): void { }

    }
